import React from "react";
import getSize from "../../../utils/getSize";
import NHTable from '../../common/NHTable';
import css from './index.css';
import { message, Button, Table, Select, Input } from 'antd';
import { hasAuth, createUuid } from "../../../utils/NHCore";

/**
 * 生活用品查询
 * @author sujunming
 * @date 2018-07-03 15:45:03
 * Version: 1.0
 */
class ShypIndex extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            initParams: {},
            selectKey: '',
            columns: [],
        }
    }

    handleOtpBtnClick = () => {
        this.refs.nhTable.exportExcel('生活用品购买信息');
    }
    render() {
        const columnConst = [
            {
                title: '序号',
                dataIndex: 'ROW_ID',
                width: '50px',
            }, {
                title: '学号',
                dataIndex: 'XH',
                width: '120px',
                searchType:"input"
            }, {
                title: '姓名',
                dataIndex: 'XM',
                width: '90px',
                search: 'input',
                searchType:"input"
            }, {
                title: '性别',
                width: '70px',
                dataIndex: 'XB',
                searchType:"select"
            }, {
                title: '身份证号',
                dataIndex: 'SFZJH',
                width: '160px',
                searchType:"input"
            }, {
                title: '院系',
                width: '200px',
                dataIndex: 'BMMC',
                searchType:"select"
            }, {
                title: '专业',
                width: '200px',
                dataIndex: 'ZYMC',
                searchType:"select",
                parentField:"BMMC"
            }, {
                title: '班级',
                width: '200px',
                dataIndex: 'BJMC',
                searchType:"select",
                parentField:"ZYMC"
            }, {
                title: '物品名称',
                width: '100px',
                dataIndex: 'WPMC',
                searchType:"input"
            }, {
                title: '数量',
                width: '100px',
                dataIndex: 'GMSL',
                searchType:"input"
            }
        ];
        
        return (
            <div className={css.main_right_content} style={{ height: getSize().windowH - 123 }}>
                <div style={{ width: '100%', height: '100%', }}>
                    <NHTable
                        ref='nhTable'
                        rowKey={record => record.PKID}
                        sign={"zhxg_yxxt_tjcx_shypcx_queryPage"}
                        columns={columnConst}
                        rangeFilter={true}
                    >
                        {hasAuth("zhxg_yxgl_tjcx_shypcx:export") ? <Button type="primary" ghost onClick={this.handleOtpBtnClick} style={{ marginLeft: 10 }}>导出</Button> : undefined}
                    </NHTable>

                </div>
            </div>
        )
    }
}

export default ShypIndex;



// WEBPACK FOOTER //
// ./components/tjcx/shypcx/index.js